import type { FaireProductEntity } from "../../entity_types/product";

export const p_nj4x5atw54: FaireProductEntity = {
  token: "p_nj4x5atw54",
  type: "product",
  name: "Organic Everyday Extra Virgin Olive Oil",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/a950bb6fafcfd90150fea3ac4558ad2db93856546370026da112da8c7d2eafe4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00e675b05fea126b710f685c6fa65eec3fabd708501d8c382858abd0f135580f.png",
    "https://cdn.faire.com/fastly/f5f48f343be81132b98500c461bd63ce39e65d5508951b1bf16c7ce0b84344f2.jpeg",
    "https://cdn.faire.com/fastly/de5f997e7dd80fe5031e4507619d2ff822d038ce21434b884e73f703a58b72a2.jpeg",
    "https://cdn.faire.com/fastly/f7935d71005e8181ea235ee2d3cfc292c6cd73ec6663095b63986bfc5348f2fb.jpeg",
    "https://cdn.faire.com/fastly/4e7c282dcd794f107ed398113230587cf3c1ff0afb23dd1202e7a0a0a0d50732.jpeg"
  ],
  priceDollars: 13.48,
  description: "Cold pressed from organic Sicilian olives, our new Everyday Olive Oil is bright and balanced with a peppery finish. Grown across Sicily’s many micro climates, organic Sicilian heirloom olives are cold-pressed to create a pure extra virgin olive oil that is the best olive oil for cooking you can find. Designed to accompany your everyday recipes, savor the enduring flavors of Italy everyday.\n\n",
  tags: [],
  msrpDollars: 26.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:23.094Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
